import { Signatory, SignOff } from "../../../api/Api";
import { getRuntimeConfig } from "../../../runtimeConfig/runtime-config";

// Hardcoded CEO who must sign off on every request, always as the final signatory.
// Change here requires a redeploy; if this needs to vary per environment, move it to
// runtime config (public/config.js) instead.
export const SIGN_OFF_CEO: Signatory = getRuntimeConfig().PUBLIC_IS_TEST_ENV
  ? {
      name: "Anna Sofie Bukh-Eriksen",
      email: "asb@mft-energy.com",
      order: 0,
      isCeo: true,
      signed: false
    }
  : {
      name: "Bo Palmgren",
      email: "bp@mft-energy.com",
      order: 0,
      isCeo: true,
      signed: false
    };

export const isCeoEmail = (email: string | undefined | null): boolean =>
  !!email && email.toLowerCase() === SIGN_OFF_CEO.email.toLowerCase();

// True when the given email is one of the sign-off signatories. The signatory list is the
// source of truth for who may take part in a sign-off (sign, reject, comment).
export const isSignatoryEmail = (
  signOff: SignOff | null | undefined,
  email: string | undefined | null
): boolean =>
  !!email &&
  (signOff?.signatories ?? []).some(
    (s) => s.email.toLowerCase() === email.toLowerCase()
  );
